(ns ui.view.card.tasks.model
  (:require
   [common.util :as cu]
   [clojure.string :as string]))

(defn delete-task-confirmation-modal-id
  [{:keys [card-state-path] :as _ctx}]
  (str
   (->> card-state-path
        (mapv (fn [part]
                (if (keyword? part)
                  (cu/kw->str part)
                  part)))
        (string/join "-"))
   "-delete-task-confirmation-modal"))
